
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function RoughCountryCard({ data }) {
    const navigate = useNavigate();
    const [loaderShow, setLoaderShow] = useState(false);
    const inventoryStock = Number(data.tn_stock) + Number(data.nv_stock);
    const availability = data.availability;


    const imageUrl =
        data.image_1 && data.image_1.trim() !== ""
            ? data.image_1
            : data.image_2 && data.image_2.trim() !== ""
                ? data.image_2
                : "/images/coming_soon.jpg";

    const handleClick = () => {
        setLoaderShow(true);
        // const productName = `${data.title || "Rough Country Product"} - ${data.sku}`;
        const sku = data.sku;

        // localStorage.setItem('selectedProduct', JSON.stringify(data));
        localStorage.setItem('inProductPage', JSON.stringify(true));

        setTimeout(() => {
            navigate(`/rough-country-product-details/${sku}`);
            setLoaderShow(false);
        }, 1000);
    };

    const isPastEta = (eta) => {
        if (!eta?.startsWith("ETA")) return false;

        const dateStr = eta.replace("ETA", "").trim();
        const etaDate = new Date(dateStr);

        if (isNaN(etaDate)) return false;

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        etaDate.setHours(0, 0, 0, 0);

        return etaDate < today;
    };

    return (
        <div className="col-lg-3 col-6" style={{ display: "contents" }}>
            <div className="Drivetrain-cart wheelsPage">
                {/* {data.msrp_usd && data.msrp_usd >= 100 && (
                    <div className="ribbon"><span>Free Shipping</span></div>
                )} */}

                <div className="engle-imge-upper" onClick={handleClick}>
                    {
                        !loaderShow ?
                            <button className="hover-btn " >  View Details </button>
                            :
                            <button className="hover-btn loading " > Loading  </button>
                    }
                    {
                        data && imageUrl ?
                            <img className="" src={imageUrl} alt="img" height="100%" width="100%" />
                            :
                            <img className="w-100 h-auto" src="/images/coming_soon.jpg" alt="img" height="100%" width="100%" />
                    }
                </div>

                <div className="cart-body">
                    <span onClick={handleClick} style={{ cursor: "pointer" }}>
                        <h1>{data.category}</h1>
                        <span className="m-0 description text-dark">
                            {data.title || "Rough Country Product"}
                        </span>
                    </span>

                    <div className="price-cart">
                        <div className="price mt-2">
                            <strong>{data.sku}</strong>
                        </div>
                        {/* <div className="price" title="Stock">
                            {availability?.startsWith("ETA") && !isPastEta(availability) ? null : (
                                inventoryStock === 0 ? (
                                    <span>
                                        <i className="fa fa-industry text-danger" aria-hidden="true"></i>{" "}
                                        {inventoryStock}
                                    </span>
                                ) : (
                                    <span>
                                        <i className="fa fa-industry text-success" aria-hidden="true"></i>{" "}
                                        {inventoryStock}
                                    </span>
                                )
                            )}
                        </div> */}

                        <div className="price" title="Stock">
                            {Number(inventoryStock) <= 0 &&
                                ((availability?.trim().toUpperCase().startsWith("ETA") && !isPastEta(availability)) ||
                                    availability?.trim().toUpperCase().startsWith("PLEASE")) ? (
                                <span>
                                    <i className="fa fa-industry text-success" aria-hidden="true"></i>{" "}
                                    1
                                </span>
                            ) : (
                                <span>
                                    <i
                                        className={`fa fa-industry ${Number(inventoryStock) > 0 ? "text-success" : "text-danger"
                                            }`}
                                        aria-hidden="true"
                                    ></i>{" "}
                                    {inventoryStock}
                                </span>
                            )}
                        </div>

                    </div>

                    <div className="price-cart mt-3">
                        <div className="price">
                            <h1 className="m-0">
                                ${parseFloat(data.price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                            </h1>
                        </div>

                        <div className="cart-btn">
                            <a
                                // href={`/rough-country?brandname=${data.product_description}`}
                                style={{ cursor: "pointer" }}
                            >

                                <img
                                    src="https://media.roughcountry.com/media/catalog/product/r/c/rc-logo-stamp2.jpg"
                                    alt="Brand Logo"
                                    height="100%"
                                    width="100%"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}